import { convertUtcToLocal } from "../../utils/functions";

export const CImpColumns = [
    {
      // 1. Date (Optional to sort by date, default is from new to old) [timestamp] - split
      Header: "Date",
      accessor: "",
      sort: false,
      //Cell: ({ row }: any) => `${row.original.timestamp.split('T')[0]}`,
      Cell: ({ row }: any) =>
        `${convertUtcToLocal(row.original.timestamp, 'DD/MM/YYYY')}`,
  
    },
    {
      // 2. Time (Optional to sort by time, default is from new to old) [timestamp] - split
      Header: "Time",
      accessor: "",
      sort: false,
      //Cell: ({ row }: any) => `${row.original.timestamp.split('T')[1].split('.')[0]}`,
      Cell: ({ row }: any) =>
        `${convertUtcToLocal(row.original.timestamp, 'HH:mm')}`,
  
    },
    {
      // 3. URL [url]
      Header: "XFF",
      accessor: "full ip",
      sort: false,
  
    },
    {
      Header: "ORIGIN-PORT",
      accessor: "oport",
      sort: false,
    },
    {
      Header: "XFF-PORT",
      accessor: "xport",
      sort: false,
    },
    {
      // 3. URL [url]
      Header: "WEB/APP",
      accessor: "web/app",
      sort: false,
  
    },
    {
      // 4. Referrer [referrer]
      Header: "User ID",
      accessor: "web_id",
      sort: false,
      Cell: ({ row }: any) =>
        `${row.original.web_id ? row.original.web_id : row.original.inapp_id}`,
  
    },
    /*{
      // 5. Client Type [clientType]
      Header: "InApp Id",
      accessor: "inapp_id",
      sort: false,
      
    },*/
    {
      // 6. Client Type [clientType]
      Header: "SHA1",
      accessor: "sha1",
      sort: false,
  
    },
    {
      // 7. Client Name [clientName]
      Header: "Domain",
      accessor: "domain",
      sort: false,
  
    },
    {
      // 8. Device Type [devicetype]
      Header: "Bundle",
      accessor: "bundle",
      sort: false,
  
    },
    {
      // 9. Device Brand [deviceBrand]
      Header: "App Name",
      accessor: "appName",
      sort: false,
  
    },
    {
      // 10. Device Model [deviceModel]
      Header: "Page",
      accessor: "page",
      sort: false,
  
    },
    {
      // 11. OS Name [osName]
      Header: "Country",
      accessor: "country",
      sort: false,
  
    },
    {
      // 12. userAgent [userAgent]
      Header: "IPv4",
      accessor: "ip",
      sort: false,
  
    },
    {
      // 13. userAgent [userAgent]
      Header: "IPv6",
      accessor: "ipv6",
      sort: false,
    },
    {
      Header: "JS_PLATFORM",
      accessor: "js_platform",
      sort: false,
    },
    { 
      Header: "JS_PLATFORM_VERSION",
      accessor: "js_plarform_version",
      sort: false,
    },
    {
      Header: "JS_BROWSER_VERSION",
      accessor: "js_browser_version",
      sort: false,
    },
    {
      Header: "JS_MODEL",
      accessor: "js_model",
      sort: false,
    },
    {
      Header: "IPv6_New",
      accessor: "new_ipv6",
      sort: false,
    },
    {
      // 14. OS Version [osVersion]
      Header: "User Agent",
      accessor: "ua",
      sort: false,
      //width:900,
      minWidth: 500,
  
    }
  
  ];